// 视口监听自定义指令
import { nextTick } from 'vue';

export const vIntersect = {
  mounted(el, binding) {
    // 获取绑定的回调函数
    const { enter, leave, threshold = 0.1 } = binding.value || {};
    
    // 创建Intersection Observer实例
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // 获取元素的class名称，用于识别组件
        const className = entry.target.className;
        if (entry.isIntersecting) {
          // 当元素进入视口时调用enter回调
          console.log('组件进入视口:', className);
          if (typeof enter === 'function') {
            enter();
          }
        } else {
          // 当元素离开视口时调用leave回调
          console.log('组件离开视口:', className);
          if (typeof leave === 'function') {
            leave();
          }
        }
      });
    }, {
      threshold // 当元素10%进入视口时触发
    });
    
    // 观察绑定的元素
    observer.observe(el);
    
    // 将observer实例存储在元素上，以便在unmounted时清理
    el._intersectionObserver = observer;
  },
  unmounted(el) {
    // 清理Observer实例
    if (el._intersectionObserver) {
      el._intersectionObserver.disconnect();
      delete el._intersectionObserver;
    }
  }
};